module.exports = __webpack_public_path__ + "static/GORETEX_SURROUND-1cd004e72611b7ab9fa3d2e851a9de8b.svg";